<nz-spin [nzSpinning]="loading">
  <nz-row>
    <form nz-form [formGroup]="form" (ngSubmit)="submitForm()">
      <nz-row [nzGutter]="24">

        <nz-col [nzSpan]="16">
          <nz-form-item>
            <nz-form-label nzFor="dateOfReceipt" nzRequired>
              <span>Datum der Annahme</span>
            </nz-form-label>
            <nz-form-control [nzErrorTip]="requiredMsg('Datum der Annahme')">
              <nz-date-picker id="dateOfReceipt" formControlName="dateOfReceipt" nzFormat="dd.MM.yyyy"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>
      <nz-row [nzGutter]="24">

        <nz-col [nzSpan]="12">
          <nz-form-item>
            <nz-form-label nzFor="placeOfReceipt" nzRequired>
              <span>Ort der Annahme</span>
            </nz-form-label>
            <nz-form-control [nzErrorTip]="requiredMsg('Ort der Annahme')">
              <nz-select id="placeOfReceipt" formControlName="placeOfReceipt" (nzOnSearch)="onSearchStores($event)"               [compareWith]="compareSimpleList"
                >
                @for (store of (storesList); track store) {
                  <nz-option [nzLabel]="store.value" [nzValue]="{id: store.id}"></nz-option>
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        <nz-col [nzSpan]="12">
          <nz-form-item>
            <nz-form-label nzFor="receivedBy" nzRequired>
              <span>Mitarbeiter</span>
            </nz-form-label>
            <nz-form-control [nzErrorTip]="requiredMsg('Mitarbeiter')">
              <nz-select id="receivedBy" formControlName="receivedBy" (nzOnSearch)="onSearchUsers($event)" nzServerSearch [compareWith]="compareSimpleList">
                @for (o of usersList; track o) {
                  @if (!isUsersLoading) {
                    <nz-option [nzValue]="o" [nzLabel]="o.value"></nz-option>
                  }
                }
                @if (isUsersLoading) {
                  <nz-option nzDisabled nzCustomContent>
                    <i nz-icon nzType="loading" class="loading-icon"></i> Daten laden...
                  </nz-option>
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>
      <nz-row nzGutter="12">
        <nz-col nzSpan="12">
          <nz-form-item>
            <nz-form-label>Status</nz-form-label>
            <nz-form-control>
              <nz-select id="status" formControlName="status" [nzDisabled]="false" >
                @for (status of complaintsStatuses; track status) {
                  <nz-option [nzLabel]="status.value" [nzValue]="status.id"> </nz-option>
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>
      <nz-row>
        <nz-col [nzSpan]="24">
          <nz-form-label>
            <span>Kommentar</span>
          </nz-form-label>
          <nz-form-item>
            <nz-form-control>
              <textarea nz-input id="remarks" formControlName="remarks" [nzAutosize]="{ minRows: 6, maxRows: 8 }"></textarea>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>
      <nz-divider nzText="Produktinformationen" nzOrientation="left"></nz-divider>
      <nz-row>
        <nz-col [nzSpan]="24">
          <nz-form-item>
            <nz-form-control>
              <div class="products-section">
                <nz-table nzBordered [nzData]="[{}]"  #tableRef
                  #editRowTable
                  nzBordered
                  [nzShowPagination]="false">
                  <thead>
                    <tr>
                      <th width="40%">Produktname</th>
                      <th width="10%">Artikelnummer</th>
                      <th width="50%">Fehlerbeschreibung</th>
                      <th nzAlign="center">
                        <span id="add-product-row">
                          <app-icon-button
                            icon="plus"
                            ariaLabel="Produkt hinzufügen"
                            (pressed)="addProduct()"
                          ></app-icon-button>
                        </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (product of form.get('products')['controls']; track product; let i = $index) {
                      <tr
                        (click)="startEdit(i)"
                        formArrayName="products"
                        class="editable-row"
                        >
                        <ng-container [formGroupName]="i">
                          <td width="40%">
                            <div class="editable-cell" [hidden]="editRow === i && product['controls'].isNew.value">
                              {{ product['controls'].productName.value }}
                            </div>
                            <nz-select
                              style="width: 100%"
                              nzPlaceHolder="Artikel auswählen"
                              nzShowSearch
                              nzServerSearch
                              nzAllowClear
                              formControlName="product"
                              [nzStatus]="isSubmitted && product['controls'].productName.errors?.required ? 'error' : ''"
                              [hidden]="editRow !== i || !product['controls'].isNew.value"
                              (ngModelChange)="productChange($event);"
                              (nzOnSearch)="onArticleSearch($event)"
                              >
                              @for (o of articlesList; track o) {
                                @if (!isArticlesLoading) {
                                  <nz-option [nzValue]="o.id" [nzLabel]="o.value"></nz-option>
                                }
                              }
                              @if (isArticlesLoading) {
                                <nz-option nzDisabled nzCustomContent>
                                  <i nz-icon nzType="loading" class="loading-icon"></i> Daten laden...
                                </nz-option>
                              }
                            </nz-select>
                            @if (isSubmitted && product['controls'].productName.errors) {
                              <div class="invalid-feedback">
                                @if (product['controls'].productName.errors.required) {
                                  <div>{{ requiredMsg('Produktname') }}</div>
                                }
                              </div>
                            }
                          </td>
                          <td width="10%">
                            <input
                              type="text"
                              nz-input
                              formControlName="articleNumber"
                              readonly
                              >
                          </td>
                          <td width="50%">
                            <textarea
                              nz-input
                              formControlName="defectDescription"
                              [nzAutosize]="{ minRows: 1, maxRows: 3 }"
                            ></textarea>
                          </td>
                          <td nzAlign="center">
                            <app-icon-button
                              icon="delete"
                              [ariaLabel]="'Produktzeile löschen'"
                              confirmTitle="Diese Produktzeile wirklich entfernen?"
                              (confirmed)="deleteRow(i)"
                            ></app-icon-button>
                          </td>
                        </ng-container>
                      </tr>
                    }
                  </tbody>
                </nz-table>
              </div>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>

      <nz-row>
        <nz-col [nzSpan]="24">
          <nz-form-item>
            <nz-form-label nzFor="deliveryNote">
              <span>Lieferschein-Nummer für Umlagerung</span>
            </nz-form-label>
            <nz-form-control>
              <input nz-input id="deliveryNote" formControlName="deliveryNote" />
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>

      <nz-row>
        <nz-col [nzSpan]="24">
          <nz-form-item>
            <nz-divider></nz-divider>
            <nz-form-label>
              <span>Dokumente</span>
            </nz-form-label>
            <nz-form-control>
              <div class="d-flex align-items-center" style="gap: 8px;">
                <nz-upload
                  [nzAction]="toolsService.getUploadDocumentUrl(uploadDocumentTypes.COMPLAINT)"
                  [nzHeaders]="{ authorization: 'authorization-text' }"
                  nzAccept="application/pdf"
                  [nzShowUploadList]="false"
                  nzMultiple
                  [nzDisabled]="isFileUploading"
                  (nzChange)="handleChange($event)"
                  >
                  <button nz-button type="button">
                    <i nz-icon nzType="upload"></i>
                    Zum Hochladen klicken
                  </button>
                </nz-upload>
                @if (isFileUploading) {
                  <nz-spin nzSimple nzSize="small"></nz-spin>
                }
              </div>
              @if (form.get('documentKeys').value.length > 0) {
                <div style="margin-top: 8px;">
                  @for (doc of form.get('documentKeys').value; track doc) {
                    <div class="d-flex align-items-center file-actions">
                      {{ doc }}
                      <app-download-document
                        [documentKey]="doc"
                      ></app-download-document>
                      <i
                        nz-icon
                        nzType="delete"
                        nzTheme="outline"
                        nz-popconfirm
                        nzPopconfirmTitle="Sind Sie sicher?"
                        nz-tooltip
                        nzTooltipTitle="Dokument löschen"
                        (nzOnConfirm)="removeDoc(doc)"
                      ></i>
                    </div>
                  }
                </div>
              }
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>

      <nz-divider nzText="Kundendaten" nzOrientation="left"></nz-divider>

      <nz-row [nzGutter]="24">
        <nz-col [nzSpan]="12">
          <nz-form-item>
            <nz-form-label nzFor="customerName" nzRequired>
              <span>Name</span>
            </nz-form-label>
            <nz-form-control [nzErrorTip]="requiredMsg('Name')">
              <input nz-input id="customerName" formControlName="customerName" />
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>

      <nz-row [nzGutter]="24">
        <nz-col [nzSpan]="12">
          <nz-form-item>
            <nz-form-label nzFor="phoneNumber" nzRequired>
              <span>Telefon</span>
            </nz-form-label>
            <nz-form-control [nzErrorTip]="requiredMsg('Telefon')">
              <input nz-input id="phoneNumber" formControlName="phoneNumber" />
            </nz-form-control>
          </nz-form-item>
        </nz-col>

        <nz-col [nzSpan]="12">
          <nz-form-item>
            <nz-form-label nzFor="emailAddress" nzRequired>
              <span>E-Mail</span>
            </nz-form-label>
            <nz-form-control [nzErrorTip]="emailErrorTpl">
              <input nz-input id="emailAddress" type="email" formControlName="emailAddress" />
            </nz-form-control>
            <ng-template #emailErrorTpl let-control>
              @if (control.errors?.required) {
                {{ requiredMsg('E-Mail') }}
              } @else if (control.errors?.email) {
                {{ invalidEmailMsg() }}
              }
            </ng-template>
          </nz-form-item>
        </nz-col>
      </nz-row>

      <nz-row>
        <nz-col [nzSpan]="24">
          <nz-form-label nzFor="shippingAddress"   nzRequired>
            <span>Versandanschrift</span>
          </nz-form-label><br>
          <nz-form-item>
            <nz-form-control [nzErrorTip]="requiredMsg('Versandanschrift')">
              <textarea nz-input id="shippingAddress" formControlName="shippingAddress" [nzAutosize]="{ minRows: 4, maxRows: 6 }"></textarea>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>
    </form>
  </nz-row>
</nz-spin>
